<template>
    <div class="center-page">
        <div class="top_change" @click="goBack">
            <div class="l_where">系统设置<span>/</span>{{ centerDate.name }}</div>
            <div class="r_back" @click="goBack">
                <i class="iconfont icon-fanhui"></i>
            </div>
        </div>
        <div class="center-nav">
            <div class="center-cont">
                <div class="jianjie">
                    <div class="pur-nam" style="margin-left:20px">{{ centerDate.name }}</div>
                    <div class="int-nam" style="margin-left:20px">{{ centerDate.describe }}</div>
                    <div class="shop-items" style="margin-left:20px">
                        <div
                        v-for="(item, index) in centerDate.price_group"
                        :key="index"
                        class="shop-but"
                        @click="goPay(item)"
                        >
                        <div class="left-shopping"></div>
                        <div class="shop-text"><span class="daole">￥</span>{{item.price}}<span v-if="centerDate.permissions_id == '1000' || centerDate.permissions_id == '1006'">/{{item.number}}{{ centerDate.permissions_id == '1006' ? '积分' : '条' }}</span></div>
                        <div class="original-text" v-if="item.original_price != 0"> 原价:<span >￥{{item.original_price}}</span></div>
                        </div>            
                    </div>
                </div>
            </div>
            <Divider />
            <div class="bottom-swip">
                <div v-html="centerDate.details_information"></div>
            </div>
        </div>
        
        <Modal v-model="showPay" :mask-closable="false" footer-hide width="600px" >
            <div class="mod-pay-cont">
            <div class="cha-cha" @click="closeMod"><img src="@/assets/setimg/guanbi.png" /></div>
            <div class="pay-title" ><span > {{ centerDate.name }}</span></div> 
            <div class="pay-num"><span class="line"> ￥{{formDate.price}}</span></div>
            <div class="pay-pay">
                <div class="pay-items"> <img @click="goPayMoney(1)" src="@/assets/setimg/weixin.png" /><div style="margin:0 5px"><Radio @on-change="payWechat" v-model="wechat">微信支付</Radio></div> </div>
                <div class="pay-items"> <img @click="goPayMoney(2)"  src="@/assets/setimg/zhifubao.png" /><div style="margin:0 5px"><Radio disabled  @on-change="payMoth" v-model="zfbchat">支付宝支付</Radio></div> </div>
            </div>
            </div>
        </Modal>
        <Modal v-model="payMa" :mask-closable="false" footer-hide width="520" class-name="center-pay-modal">
            <div class="pay-modal">
                <Icon type="ios-close" class="pay-modal__close" @click="closePay" />
                <div class="pay-modal__header">
                    <img v-if="wechat" class="pay-modal__wx-icon" src="@/assets/setimg/weixin.png" alt="" />
                    <img v-if="zfbchat" class="pay-modal__wx-icon" src="@/assets/setimg/zhifubao.png" alt="" />
                    <div class="pay-modal__title">{{ zfbchat ? '请使用支付宝扫码付款' : '请使用微信扫码付款' }}</div>
                </div>
                <div class="pay-modal__price-wrap">
                    <span class="pay-modal__price">¥{{ formDate.price }}</span>
                </div>
                <div class="pay-modal__qrcode">
                    <Spin fix v-if="PayEWM == '' && !payQrcodeFailed">
                        <Icon type="ios-loading" size="32" class="pay-modal__spin" />
                        <div class="pay-modal__loading-text">二维码加载中...</div>
                    </Spin>
                    <div v-else-if="payQrcodeFailed" class="pay-modal__qrcode-error">
                        <Icon type="ios-close-circle-outline" size="40" color="#ed4014" />
                        <div class="pay-modal__error-text">{{ payQrcodeErrorMsg }}</div>
                    </div>
                    <img v-else class="pay-modal__qrcode-img" :src="PayEWM" alt="支付二维码" />
                </div>
                <div class="pay-modal__tip">支付完成后将自动跳转，请勿关闭此窗口</div>
            </div>
        </Modal>
        <Modal v-model="paySucces" :mask-closable="false" footer-hide width="520" class-name="center-pay-modal">
            <div class="pay-success">
                <Icon type="ios-close" class="pay-modal__close" @click="closeSuc" />
                <img class="pay-success__icon" src="@/assets/setimg/zhifuwancheng.png" alt="" />
                <div class="pay-success__title">恭喜你支付完成!</div>
                <div class="pay-success__card">
                    <div class="pay-success__row">
                        <span class="pay-success__label">商品订单</span>
                        <span class="pay-success__value">{{ payFormData.order_no }}</span>
                    </div>
                    <div class="pay-success__row">
                        <span class="pay-success__label">商品名称</span>
                        <span class="pay-success__value">{{ centerDate.name }}</span>
                    </div>
                    <div class="pay-success__row">
                        <span class="pay-success__label">支付金额</span>
                        <span class="pay-success__value pay-success__value--price">
                            ¥{{ payFormData.pay_money }}<template v-if="payFormData.number != 0">/{{ payFormData.number }}条</template>
                        </span>
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import { cs_chargepay,get_orderstatus,get_menulist }from "@/api/center.js"; 
import vm from '@/utils/util.js'
import { getApiErrorMsg } from '@/utils/helper'
export default {
    name: "purchase",
    components: {
        // modal
    },
    data() {
        return {   
            formDate: {
                describe: "",
                id: "",
                number: 0,
                price: "",
                type: "",
            },
            paySucces: false,
            spinShow: false,
            centerDate:{
                icon: "",
                id: "",
                is_menu: "",
                is_rightmenu: "",
                is_submenu: "",
                path: "",
                permissions_name: "",
                permissions_rote: "",
                permissions_id: "",
                route_name: "",
                pid: "",
                type: "",
                plug_id: "",
                hasOriginal: "",
            },
            payFormData: {
                pay_money: "",
                order_no:  "",
                number: 0
            },
            payMa: false,
            showPay: false,
            zfbchat: false,
            wechat: false,
            PayEWM: "",
            payQrcodeFailed: false,
            payQrcodeErrorMsg: '',
            timer: "",
        };
    },
    created() {        
        this.centerDate = JSON.parse(localStorage.getItem("centerType"))   
        localStorage.setItem("payOver",'')        
    },
    computed: {
        userInfo(){
            return this.$store.state.userInfo
        },
    },
    mounted() {
        var that = this
        vm.$on('demo', function (msg) {
            console.log('msg',msg)
            that.payOK(msg)
        })
    },
    methods: {     
        payOK(a){
            // let a = JSON.parse(e)
            if(a.code == 200){
                if(this.payMa){
                    this.paySucces = true
                    this.payMa = false
                    this.showPay = false
                    this.payFormData.pay_money = a.data.pay_money
                    this.payFormData.order_no = a.data.order_no
                    this.payFormData.number = a.data.number 
                }
                this.get_menulist()
            }else{
                console.log('出错了')
            }
        }, 
        goBack() {
            this.$emit("goBack");
        }, 
        goPay(e) {
            // this.showPay = true;
            // this.zfbchat = false
            // this.wechat = false     
            // 增加询问框 
            let that = this
            this.$Modal.confirm({
                title: '提示',
                content: '是否确认购买'+that.centerDate.name,
                onOk: () => {  
                    that.formDate = e 
                    that.payMa = true
                    that.goPayMoney(1)   
                },
                onCancel: () => {
                    // 取消删除
                }
            })    
        },       
        onPayQrcodeFailed(msg) {
            this.payQrcodeFailed = true
            this.payQrcodeErrorMsg = msg
            this.$Message.error(msg)
        },
        goPayMoney(e){
            if(e == 1){
                this.PayEWM = ""
                this.payQrcodeFailed = false
                this.payQrcodeErrorMsg = ''
                this.zfbchat = false
                this.wechat = true
                this.payMa = true
                let data={
                    type:0,
                    price_id: this.formDate.id,
                    uniacid_id: this.userInfo.uniacid_id,
                    application_id: this.centerDate.plug_id,
                    payment_type: 1 ,  //1微信  2支付宝
                }
                cs_chargepay(data).then(res=>{     
                    if(res.code == 400 && this.centerDate.permissions_id != 1000 && this.centerDate.permissions_id != 1006){
                        this.payMa = false
                        return  this.$Message.error(res.msg)
                    }
                    const payData = res && res.data
                    if (!payData || !payData.qrcode_url) {
                        this.onPayQrcodeFailed('获取支付二维码失败')
                        return
                    }
                    this.PayEWM = payData.qrcode_url
                    this.pollingOrder(payData.out_trade_no)
                }).catch(res=>{
                    if(res.code == 400 && this.centerDate.permissions_id != 1000 && this.centerDate.permissions_id != 1006){
                        this.payMa = false
                        return this.$Message.error(getApiErrorMsg(res, '发起支付失败'))
                    }
                    this.onPayQrcodeFailed(getApiErrorMsg(res, '发起支付失败'))
                })
            }else{
                // this.wechat = false
                // this.zfbchat = true
                // this.payMa = true
            }
        },
        pollingOrder(e){
            this.timer = setInterval(() => {
                this.$store.commit('changePollingSpin', false)
                get_orderstatus({order_no:e}).then(res=>{
                    if(res.data.is_pay == 1){
                        this.payOK(res)
                        clearInterval(this.timer)
                    }
                    this.$store.commit('changePollingSpin', true)
                }).catch(res=>{
                    this.$store.commit('changePollingSpin', true)
                    this.$Message.error(res.msg)
                    clearInterval(this.timer)
                })
            }, 2000)
        },
        closeMod(){
            this.showPay = false
        },
        closePay(){
            this.payMa = false
            this.payQrcodeFailed = false
            this.payQrcodeErrorMsg = ''
            clearInterval(this.timer)
        },
        closeSuc(){
            this.paySucces = false
        },
        get_menulist(){
            get_menulist().then(res=>{
                this.$store.commit('setAuth', res.data.unique_auth)  
                this.$store.commit('setMenus', res.data.menuAll)                
                let arr = []
                res.data.menuAll.forEach(item=>{
                    if(item.permissions_rote === 'settingIndex'){
                        arr=item.children
                    }
                })
                this.$store.commit('setSetting', arr)

            }).catch(res=>{
                this.$Message.error(res.msg)
            })
        },
        payMoth(e){
            if(e){
                this. wechat = false
                //  this.zfbchat = true
                //  this.payMa = true
            }
        },
        payWechat(e){
            if(e){
                this.goPayMoney(1)
            }              
        },
    },
};
</script>

<style scoped lang="scss">
::v-deep .ivu-modal-close  {
    display: none;
}
::v-deep .bottom-swip img{
    max-width: 100%;
    max-height: 100%;
}
.bottom-swip{
    width: 100%;
    margin-top: 35px;
    overflow: hidden;
}
.cha-cha {
    cursor: pointer;
    position: absolute;
    overflow: hidden;
    color: #fff;
    z-index: 1;
    right: -50px;
    top: -20px;
}
.pay-pay{
    display: flex;
    align-items: center;
    justify-content: center;
    .pay-items{
        padding: 50px 0;
        width: 50%;
        text-align: center;
        img {
            cursor: pointer;
            width: 90px;
            height: 90px;
        }
    }
}
.over-list {
    text-align: start;
    margin: 20px 0px;
    font-size: 15px; 
    color: #000000;
    margin-left: 190px ;
    span {
        color: #666666;
    }
}
.center-cont {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .jianjie {
        width: 100%;
        height: 100%;
    }    
    .pur-nam {
        color: #1b2742;
        font-size: 20px;
        margin-top: 12px ;
        font-family: PingFang SC;
        font-weight: bold;
    }
    .int-nam {
        width: 100%;
        height: 95px;
        margin-top:8px;
        padding: 5px;
        font-family: PingFang SC;
        font-size: 15px;
        color: #545f78;
        // overflow: scroll;
        overflow: hidden;
        // display: block;
    }
    .int-nam::-webkit-scrollbar{
        display: none;
    }
    .shop-items {
        user-select: none;
        display: flex;
        flex-flow: wrap;
        font-family: PingFang SC;
        .shop-but {
            margin-top:10px ;
            padding: 5px 10px;
            margin-right: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 0.5px solid #4877e8;
            border-radius: 8px;
            cursor: pointer;
            position: relative;
            .left-shopping {
                margin-left: 10px;
                width: 20px;
                height: 20px;
                padding:  5px;
                background: url('../../../assets/setimg/gouwuche.png') no-repeat 0px 3px;;        
            }
            .shop-text {
                text-align: center;
                padding-left: 10px;
                padding-right: 20px;
                color: #fe511c;
                font-size: 22px;
                span {
                    font-size: 16px;
                    color: #4877e8;
                }
                .daole {
                    font-size: 16px;
                    color: #fe511c;
                }
            }
            .original-text{
                color: #999999;
                font-size: 12px;word-break:keep-all;white-space:nowrap; 
                margin-top:6px ;
                span {
                    text-decoration:line-through
                }
            }
        }
        .shop-but:hover{
            padding: 5px 10px;
            margin-right: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 0.5px solid #4877e8;
            border-radius: 8px;
            cursor: pointer;
            position: relative;
            background: #4877E8;
            .shop-text {
                padding-left: 10px;
                padding-right: 20px;
                text-align: center;
                color: #fff;
                font-size: 22px;
                span {
                    font-size: 16px;
                    color: #fff;
                }
                .daole {
                    font-size: 16px;
                    color: #fff;
                }
            }
            .original-text {
                color: #fff;
            }
            .left-shopping {
                margin-left: 10px;
                width: 20px;
                height: 20px;
                padding:  5px;
                background: url('../../../assets/setimg/gouwuchebai.png') no-repeat 0px 3px;        
            }                
        }
    }
}

.mod-pay-cont{
    text-align: center;
    .pay-title{
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content: center;        
    }    
    .pay-num {
        width: 100%;
        height: 40px;
        margin-top:40px ;
        text-align: center;
        color: #4877e8;
    }
    .pay-num .line{
        position: relative;
        display: inline-block;
        padding: 0 30px;
    }    
    .pay-num .line::after{
        content:'';
        width:180px;
        position:absolute;
        top:20px;
        right:-160px;
        border-bottom:1px solid #4877E8;
    }
    .pay-num .line::before{
        content:'';
        width:180px;
        position:absolute;
        top:20px;
        left:-160px;
        border-bottom:1px solid #4877E8;
    }
    span {
        color: #545F78;
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: bold;
    }
    img {
        width: 40px;
        height: 40px;
    }
}
.center-page {
    .top_change {
        width: 100%;
        cursor: pointer;
        background: #ffffff;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 30px;
        box-sizing: border-box;
        height: 60px;
        .l_where {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #1b2742;
            span {
                color: #4877e8;
            }
        }
        .r_back {
            .iconfont {
                font-size: 26px;
                cursor: pointer;
                &:hover {
                    color: #4877e8;
                }
            }
        }
    }
    .center-nav {
        width: 100%;
        padding: 24px;
        box-sizing: border-box;
        border-radius: 8px;
        background: white;
        margin-top: 20px;        
    }
}
</style>
<style lang="scss">
.pay-modal {
    position: relative;
    text-align: center;
    padding: 8px 12px 4px;
}

.pay-modal__close {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 2;
    font-size: 28px;
    color: #999;
    cursor: pointer;
    line-height: 1;
    transition: color 0.2s;

    &:hover {
        color: #666;
    }
}

.pay-modal__header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-bottom: 20px;
}

.pay-modal__wx-icon {
    width: 28px;
    height: 28px;
}

.pay-modal__title {
    font-size: 18px;
    font-weight: 600;
    color: #545f78;
    line-height: 1.4;
}

.pay-modal__price-wrap {
    margin-bottom: 28px;
}

.pay-modal__price {
    position: relative;
    display: inline-block;
    padding: 0 28px;
    font-size: 32px;
    font-weight: 700;
    color: #4877e8;
    line-height: 1.2;

    &::before,
    &::after {
        content: '';
        position: absolute;
        top: 50%;
        width: 120px;
        border-bottom: 1px solid #d6e3ff;
    }

    &::before {
        right: 100%;
        margin-right: 8px;
    }

    &::after {
        left: 100%;
        margin-left: 8px;
    }
}

.pay-modal__qrcode {
    position: relative;
    width: 200px;
    height: 200px;
    margin: 0 auto;
    padding: 8px;
    border: 1px solid #4877e8;
    border-radius: 8px;
    background: #fff;
    box-sizing: border-box;
}

.pay-modal__qrcode-img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.pay-modal__spin {
    animation: center-pay-spin 1s linear infinite;
    color: #4877e8;
}

.pay-modal__loading-text {
    margin-top: 10px;
    font-size: 13px;
    color: #8a94a6;
}

.pay-modal__qrcode-error {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 12px;
    box-sizing: border-box;
}

.pay-modal__error-text {
    margin-top: 10px;
    font-size: 13px;
    color: #ed4014;
    line-height: 1.5;
    word-break: break-all;
}

.pay-modal__tip {
    margin-top: 20px;
    font-size: 13px;
    color: #8a94a6;
    line-height: 1.5;
}

.pay-success {
    position: relative;
    text-align: center;
    padding: 8px 8px 16px;
}

.pay-success__icon {
    width: 72px;
    height: 72px;
    margin-bottom: 12px;
}

.pay-success__title {
    font-size: 22px;
    font-weight: 700;
    color: #2f3a4f;
    margin-bottom: 24px;
}

.pay-success__card {
    text-align: left;
    background: #f7f9fc;
    border-radius: 8px;
    padding: 16px 20px;
    border: 1px solid #e9edf6;
}

.pay-success__row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding: 8px 0;
    font-size: 14px;
    line-height: 1.5;

    & + & {
        border-top: 1px dashed #e3e8f0;
    }
}

.pay-success__label {
    flex-shrink: 0;
    color: #8a94a6;
}

.pay-success__value {
    color: #2f3a4f;
    text-align: right;
    word-break: break-all;

    &--price {
        font-weight: 700;
        color: #fe511c;
    }
}

@keyframes center-pay-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.center-pay-modal {
    .ivu-modal-body {
        padding: 28px 32px 32px;
        overflow: visible;
    }

    .ivu-modal-close {
        display: none;
    }
}
</style>
